/**
 * AgentesDeLaHerramienta — GEN-TL-007: sección «Agentes» de la ficha de la
 * herramienta. Solo lectura: qué agentes la tienen y con qué nivel o niveles
 * (GET /v1/herramientas/{id}/agentes), de la ficha de cada agente. Es la vista
 * inversa de HerramientasDelAgente y lee la misma lógica en el kernel.
 */

import { useEffect, useState } from 'react'
import { getAgentesDeHerramienta } from '../api/client.js'
import MarcasConfirmacion from './MarcasConfirmacion.jsx'

export default function AgentesDeLaHerramienta({ herramientaId }) {
  const [datos, setDatos] = useState(null)

  useEffect(() => {
    setDatos(null)
    let vivo = true
    getAgentesDeHerramienta(herramientaId)
      .then(d => vivo && setDatos(d))
      .catch(() => vivo && setDatos({ error: 'No se han podido cargar los agentes.' }))
    return () => { vivo = false }
  }, [herramientaId])

  const agentes = datos?.agentes ?? []
  return (
    <section className="ficha-card" aria-label="Agentes con esta herramienta">
      <h3 className="ficha-card__titulo">Agentes que la tienen</h3>
      {!datos && <p className="equipo-estado">Cargando…</p>}
      {datos?.error && <p className="equipo-estado" role="alert">{datos.error}</p>}
      {datos && !datos.error && agentes.length === 0 && (
        <p className="ficha-card__texto">Ningún agente tiene esta herramienta.</p>
      )}
      {agentes.length > 0 && (
        <ul className="niveles-lista">
          {agentes.map(a => (
            <li key={a.id} className="niveles-lista__item">
              <span className="niveles-lista__nombre">
                {a.nombre}
                {a.estado === 'inactivo' && <span className="equipo-chip"> Inactivo</span>}
              </span>
              {a.concedido?.texto ? (
                // GEN-TL-009: el nivel concedido (el más alto) y que incluye los de debajo.
                <>
                  <p className="ficha-card__texto" aria-label={`Nivel de ${a.nombre}`}>{a.concedido.texto}</p>
                  <MarcasConfirmacion niveles={a.niveles} nombre={a.nombre} />
                </>
              ) : (
                <ul className="equipo-card__chips" aria-label={`Niveles de ${a.nombre}`}>
                  {a.niveles.map(n => (
                    <li key={n.clave_recurso} className="equipo-chip">
                      {n.nombre}
                      {n.pide_confirmacion && <span className="equipo-chip equipo-chip--confirmacion">Pide confirmación</span>}
                    </li>
                  ))}
                </ul>
              )}
            </li>
          ))}
        </ul>
      )}
    </section>
  )
}
